/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Latex from '../../latex';
import { proxiedImageUrl, UPLOADED_IMAGE_REGEX, IMAGE_REGEX, CLICKABLE_REGION_REGEX } from '../../util';
import _ from 'underscore';

var Images = function Images(self) {
  /*
   * @namespace Model
   * @mixin
   *
   */
  return {
    isImage: function isImage() {
      var value = self.attributes.value;
      /*
       * NOTE: Using `.test` return a boolean value.
       * > https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/test
       */

      return value && IMAGE_REGEX.test(value);
    },
    isImageProxyImage: function isImageProxyImage() {
      return self.get('value').match(UPLOADED_IMAGE_REGEX);
    },
    imageUrl: function imageUrl(opts) {
      // Remove legacy string arguments (for latexColor)
      if (_.isString(opts)) {
        opts = {};
      }

      if (self.isImage()) {
        if (!opts) {
          opts = {};
        } // Convert long form options to short form that ingix expects


        if (opts.width) {
          opts.w = opts.width;
          delete opts.width;
        }

        if (opts.height) {
          opts.h = opts.height;
          delete opts.height;
        }

        _.defaults(opts, {
          w: 300,
          h: 150
        });

        var url = proxiedImageUrl(self.get('value'), opts);
        return url.toString();
      } else {
        return null;
      }
    },
    isLatex: function isLatex() {
      var value = self.attributes.value;
      return value && Latex.isLatex(value);
    },
    latexEquation: function latexEquation() {
      if (self.isLatex()) {
        return Latex.getText(self.get('value'));
      } else {
        return '';
      }
    },
    isText: function isText() {
      return !(self.isImage() || self.isLatex());
    },
    isClickableRegion: function isClickableRegion() {
      return __guard__(__guard__(self.get('value'), function (x1) {
        return x1.match(CLICKABLE_REGION_REGEX);
      }), function (x) {
        return x.length;
      }) > 3;
    },
    relativeX: function relativeX() {
      if (self.regionMatches == null) {
        self.regionMatches = __guard__(self.get('value'), function (x) {
          return x.match(CLICKABLE_REGION_REGEX);
        });
      }

      if ((self.regionMatches != null ? self.regionMatches.length : undefined) > 1) {
        return parseFloat(self.regionMatches[1]);
      }
    },
    relativeY: function relativeY() {
      if (self.regionMatches == null) {
        self.regionMatches = __guard__(self.get('value'), function (x) {
          return x.match(CLICKABLE_REGION_REGEX);
        });
      }

      if ((self.regionMatches != null ? self.regionMatches.length : undefined) > 2) {
        return parseFloat(self.regionMatches[2]);
      }
    }
  };
};

export default Images;

function __guard__(value, transform) {
  return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
}